import React, { useEffect, useRef, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import defaultCover from '../Images/coverbg.jpg'
import { useNavigate } from 'react-router-dom'
import BottomNav from '../Components/BottomNav'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from 'react-bootstrap'
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import ProgressBar from 'react-bootstrap/ProgressBar';
import { app } from "../firebase.js"
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getFirestore, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import swal from 'sweetalert';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from 'react-router-dom'
import '../edtProf.css'

function EditProfile() {

    const [saveButton, setsaveButton] = useState(true);
    const [updateButton, setupdateButton] = useState(false);

    const [now, setNow] = useState(0);
    const [showProgress, setshowProgress] = useState();
    const db = getFirestore(app);
    const [userId, setUserId] = useState()
    const auth = getAuth();
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState(profDefault);
    const [coverImage, setcoverImage] = useState(defaultCover)

    const [loggedInName, setloggedInName] = useState();
    const [loggedInemail, setloggedInemail] = useState();

    //
    const nameRef = useRef();
    const phoneRef = useRef();
    const mpesaRef = useRef();

    const religiousRef = useRef();
    const politicalRef = useRef();
    const socialRef = useRef();
    const alcoholRef = useRef();
    const gamblingRef = useRef();
    const forexRef = useRef();
    const cryptoRef = useRef();
    const tradingRef = useRef();


    //get the currently signed in user
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const uid = user.uid;
                setUserId(uid)
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    // basic info
                    setloggedInName(data.userName || "")
                    setloggedInemail(data.email || "")
                    if (phoneRef.current) phoneRef.current.value = data.phoneNumber || ""
                    if (mpesaRef.current) mpesaRef.current.value = data.mpesaNumber || ""

                    // images
                    setProfileImage(data.profileImage || profDefault)
                    setcoverImage(data.coverImage || defaultCover)


                    // ads not accepted checkboxes
                    if (data.adsNotAccepted) {
                        if (religiousRef.current) religiousRef.current.checked = data.adsNotAccepted.religious || false
                        if (politicalRef.current) politicalRef.current.checked = data.adsNotAccepted.political || false
                        if (socialRef.current) socialRef.current.checked = data.adsNotAccepted.socialIssues || false
                        if (alcoholRef.current) alcoholRef.current.checked = data.adsNotAccepted.alcohol || false
                        if (gamblingRef.current) gamblingRef.current.checked = data.adsNotAccepted.gambling || false
                        if (forexRef.current) forexRef.current.checked = data.adsNotAccepted.forex || false
                        if (cryptoRef.current) cryptoRef.current.checked = data.adsNotAccepted.crypto || false
                        if (tradingRef.current) tradingRef.current.checked = data.adsNotAccepted.trading || false
                    }


                } else {
                    console.log("No such document!");
                }
            } else {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate, auth]);


    // start
    useEffect(() => {
        document.title = "Zindua App | Edit your account";

        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
            desc = document.createElement("meta");
            desc.setAttribute("name", "description");
            document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App Influencer dashboard");

        // Open Graph tags
        const ogTags = [
            { property: "og:title", content: "Zindua App | Dashboard" },
            { property: "og:description", content: "Zindua App Dashboard" },
            { property: "og:type", content: "website" },
            { property: "og:url", content: "https://zindua.app/dashboard" },
            { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];

        ogTags.forEach(({ property, content }) => {
            let tag = document.querySelector(`meta[property='${property}']`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("property", property);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        });

        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Zindua App Influencer Dashboard",
            "url": "https://zindua.app/dashboard",
            "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
            "inLanguage": "en",
            "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://zindua.app/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Dashboard",
                        "item": "https://zindua.app/dashboard"
                    }
                ]
            }
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    //updating profile image
    function handleProfileChange(e) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0]
            setProfileImage(URL.createObjectURL(file))

            const storage = getStorage();
            const storageRef = ref(storage, `profiles/${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            setshowProgress(true)

            uploadTask.on('state_changed',
                (snapshot) => {

                    //update progress
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                    setNow(progress)
                },
                (error) => {
                    // Handle unsuccessful uploads
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                        const userRef = doc(db, "users", userId);

                        updateDoc(userRef, {
                            profileImage: downloadURL
                        }).then(() => {
                            setshowProgress(false)
                            swal("success", "upload successful", "success");

                        })


                    });
                }
            );





        }

    }

    function handleCoverChange(e) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0]
            setcoverImage(URL.createObjectURL(file))


            const storage = getStorage();
            const storageRef = ref(storage, `profiles/${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            setshowProgress(true)

            uploadTask.on('state_changed',
                (snapshot) => {

                    //update progress
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                    setNow(progress)
                },
                (error) => {
                    // Handle unsuccessful uploads
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                        const userRef = doc(db, "users", userId);

                        updateDoc(userRef, {
                            coverImage: downloadURL
                        }).then(() => {
                            setshowProgress(false)
                            swal("success", "upload successful", "success");

                        })


                    });
                }
            );

        }
    }
    //end

    async function saveChanges(goNext = false) {
        setsaveButton(false)
        setupdateButton(true)

        const nameInput = nameRef.current.value;
        const mpesaInput = mpesaRef.current.value;

        if (!mpesaInput || mpesaInput.trim() === "") {
            setsaveButton(true);
            setupdateButton(false);
            swal("Error", "M-Pesa number cannot be empty", "error");
            return;
        }

        const adsNotAccepted = {
            religious: religiousRef.current.checked,
            political: politicalRef.current.checked,
            socialIssues: socialRef.current.checked,
            alcohol: alcoholRef.current.checked,
            gambling: gamblingRef.current.checked,
            forex: forexRef.current.checked,
            trading: tradingRef.current.checked,
            crypto: cryptoRef.current.checked
        };

        const userRef = doc(db, "users", userId);

        try {
            await updateDoc(userRef, {
                userName: nameInput,
                mpesaNumber: mpesaInput,
                adsNotAccepted: adsNotAccepted,
                onboardingStep: 1,
                onboardingCompleted: false
            });

            setsaveButton(true)
            setupdateButton(false)

            if (goNext) {
                navigate("/username-setup");
            } else {
                swal("success", "Profile updated", "success");
            }

        } catch (err) {
            console.error(err);
            setsaveButton(true);
            setupdateButton(false);
            swal("error", "Failed to save profile", "error");
        }
    }



    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftBar />
            </div>

            <div className='mainContent'>
                <Topbar />

                {showProgress &&
                    <ProgressBar now={now} label={`${now}%`} />
                }

                <section className='topProfile'>

                    <div className='profileCover coverWrapper'>
                        <img src={coverImage} alt="" />

                        <label className='coverOverlay'>
                            <FontAwesomeIcon icon={faCamera} className='overlayIcon' />
                            <input type="file" onChange={handleCoverChange} />
                        </label>
                    </div>

                    <div className='profilePhoto photoWrapper'>
                        <img src={profileImage} alt="" />

                        <label className='photoOverlay'>
                            <FontAwesomeIcon icon={faCamera} className='overlayIcon' />
                            <input type="file" onChange={handleProfileChange} />
                        </label>
                    </div>

                </section>

                <section className='editFormSection'>

                    <Form>

                        <Form.Group className='mb-3'>
                            <Form.Label>Your Name</Form.Label>
                            <Form.Control type='text' defaultValue={loggedInName} placeholder='Enter your name' ref={nameRef} />
                        </Form.Group>


                        <Form.Group className='mb-3'>
                            <Form.Label>Email</Form.Label>
                            <Form.Control type='email' value={loggedInemail} disabled placeholder='Enter your email' />
                        </Form.Group>

                        <Form.Group className='mb-3'>
                            <Form.Label>Mpesa Withdrawal Number. This is also the number that will receive all notifications and OTPs</Form.Label>
                            <Form.Control type='text' placeholder='07XXXXXXXX' ref={mpesaRef} />
                        </Form.Group>

                        <Form.Group className='mb-3'>
                            <Form.Label>Ads You Do Not Accept</Form.Label>

                            <div className='checkboxList'>
                                <Form.Check type='checkbox' label='Religious' ref={religiousRef} />
                                <Form.Check type='checkbox' label='Political' ref={politicalRef} />
                                <Form.Check type='checkbox' label='Social Issues' ref={socialRef} />
                                <Form.Check type='checkbox' label='Alcohol' ref={alcoholRef} />
                                <Form.Check type='checkbox' label='Gambling' ref={gamblingRef} />
                                <Form.Check type='checkbox' label='Forex' ref={forexRef} />
                                <Form.Check type='checkbox' label='Cryptocurrency' ref={cryptoRef} />
                                <Form.Check type='checkbox' label='Stock Trading' ref={tradingRef} />
                            </div>
                        </Form.Group>

                        <div className="formActions">
                            {saveButton && (
                                <>
                                    <button
                                        className="secondaryBtn"
                                        type="button"
                                        onClick={() => saveChanges(false)}
                                    >
                                        Save
                                    </button>

                                    <button
                                        className="primaryBtn"
                                        type="button"
                                        onClick={() => saveChanges(true)}
                                    >
                                        Save & Next
                                    </button>
                                </>
                            )}

                            {updateButton && (
                                <Button variant="primary" disabled className="primaryBtn">
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {" "}Saving...
                                </Button>
                            )}
                        </div>



                    </Form>

                </section>

            </div>

            <div className="mobileOnly">
                <BottomNav />
            </div>

        </div >
    )
}

export default EditProfile